import React from "react";
import useSearchParam from "hooks/useSearchParam";
import SignUpToken from "view/SignUp/SignUpToken";
import MultiStepFormProvider from "view/SignUp/SignUpToken/context";
import SignUpDeprecatedExhibitor from "view/SignUp/SignUpDeprecatedExhibitor";
import MaintenanceModeGate from "view/components/MaintenanceModeGate";

/**
 * Handles the legacy /sign-up/:uid route.
 * - If showId is present → exhibitor embedded sign-up flow (still valid)
 * - Otherwise → old invite link format, now deprecated
 */
const SignUpLegacyUidRouter = () => {
  const showId = useSearchParam("showId");
  if (showId) {
    return (
      <MaintenanceModeGate>
        <MultiStepFormProvider>
          <SignUpToken />
        </MultiStepFormProvider>
      </MaintenanceModeGate>
    );
  }
  return <SignUpDeprecatedExhibitor />;
};

export default SignUpLegacyUidRouter;
